import useEnterpriseHighlightCourses from '@/hooks/profile/enterprise/client/useEnterpriseHighlightCourses';
import { THighlightCourses } from '@/interfaces/enterprise-profile/course_tab.interface';
import EnterpriseCourseSwiper from '../../general/EnterpriseCourseSwiper';

const HomepageHighlightCoursesSection = ({
  sectionName,
}: {
  sectionName: string;
}) => {
  const {
    queryReturn: { data: suggestedCourses },
  } = useEnterpriseHighlightCourses();

  return (
    <EnterpriseCourseSwiper
      courses={(suggestedCourses as THighlightCourses).map((item) => ({
        memberList: item.recentMembers.map((item) => item.avatar),
        courseId: item.id,
        title: item.title,
        thumbnail: item.thumbnail,
        description: item.description,
        groupId: item.folderId,
        certificateShortName: item.certificateShortName,
        memberCount: item.memberCount,
      }))}
      sectionName={sectionName}
    />
  );
};
export default HomepageHighlightCoursesSection;
